import React, { useState, useEffect } from 'react';
import { contactUsPageData } from '../data/pageData';
import PageTitle from '../components/PageTitle';

const ContactUsPage = () => {
    const data = contactUsPageData;
    return (
        <div className="bg-white text-gray-800">
            <PageTitle title={data.pageTitle} breadcrumbs={data.breadcrumbs} />
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-5xl mx-auto bg-gray-50 p-8 md:p-12 rounded-xl shadow-2xl border border-gray-200">
                        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10">{data.formTitle}</h2>
                        <form className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                            <div>
                                <label htmlFor="firstName" className="block text-sm font-semibold text-gray-700 mb-1.5">First Name</label>
                                <input type="text" id="firstName" className="mt-1 block w-full bg-white border-gray-300 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-gray-900 placeholder-gray-400" placeholder="John" />
                            </div>
                            <div>
                                <label htmlFor="lastName" className="block text-sm font-semibold text-gray-700 mb-1.5">Last Name</label>
                                <input type="text" id="lastName" className="mt-1 block w-full bg-white border-gray-300 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-gray-900 placeholder-gray-400" placeholder="Doe" />
                            </div>
                            <div className="md:col-span-2">
                                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1.5">Email Address</label>
                                <input type="email" id="email" className="mt-1 block w-full bg-white border-gray-300 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-gray-900 placeholder-gray-400" placeholder="you@example.com" />
                            </div>
                            <div className="md:col-span-2">
                                <label htmlFor="subject" className="block text-sm font-semibold text-gray-700 mb-1.5">Subject</label>
                                <input type="text" id="subject" className="mt-1 block w-full bg-white border-gray-300 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-gray-900 placeholder-gray-400" placeholder="Regarding your products..." />
                            </div>
                            <div className="md:col-span-2">
                                <label htmlFor="comments" className="block text-sm font-semibold text-gray-700 mb-1.5">Comments / Questions</label>
                                <textarea id="comments" rows="6" className="mt-1 block w-full bg-white border-gray-300 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-gray-900 placeholder-gray-400" placeholder="Your message..."></textarea>
                            </div>
                            <div className="md:col-span-2 text-right">
                                <button type="submit" className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-10 py-3.5 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>

                    <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
                        {data.contactPoints.map(item => (
                            <div key={item.title} className="bg-gray-100 p-8 rounded-xl shadow-xl transform hover:scale-105 transition-transform duration-300 border border-gray-200">
                                <span className="text-yellow-500 text-4xl block mb-4">{item.icon}</span>
                                <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h3>
                                <p className="text-sm text-gray-600 leading-relaxed">{item.detail}</p>
                            </div>
                        ))}
                    </div>
                     <div className="mt-16 rounded-xl shadow-2xl overflow-hidden transform hover:scale-[1.01] transition-transform duration-500 border border-gray-200">
                        <iframe
                            src={data.mapImageSrc}
                            className="w-full h-72 md:h-96"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>
            </section>
            <style jsx global>{`
                .animation-delay-300 { animation-delay: 300ms; }
                .animate-fadeInUp { animation: fadeInUp 0.8s ease-out forwards; }
                .animate-slideInLeft { animation: slideInLeft 0.8s ease-out forwards; }
                .animate-slideInRight { animation: slideInRight 0.8s ease-out forwards; }
                .animate-slideInUp { animation: slideInUp 0.8s ease-out forwards; }
                .animate-pulseSlow { animation: pulseSlow 2.5s infinite ease-in-out; }
                .animate-wave { animation: wave 5s linear infinite alternate; }

                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideInLeft {
                    from { opacity: 0; transform: translateX(-50px); }
                    to { opacity: 1; transform: translateX(0); }
                }
                @keyframes slideInRight {
                    from { opacity: 0; transform: translateX(50px); }
                    to { opacity: 1; transform: translateX(0); }
                }
                 @keyframes slideInUp {
                    from { opacity: 0; transform: translateY(50px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes pulseSlow {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.8; transform: scale(1.03); }
                }
                 @keyframes wave {
                    0% { transform: translateX(-20px); }
                    100% { transform: translateX(20px); }
                }
            `}</style>
        </div>
    );
};

export default ContactUsPage;